import { useState, useEffect } from "react";
import { LeftBtn, RightBtn } from "../../utils/icons";
import Events from "../Events";

const Calendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date()); // Initialize with the current date

  // This function finds the previous Sunday from the current date to start the week
  const getWeekStartDate = (date) => {
    const tempDate = new Date(date);
    const day = tempDate.getDay(); // Sunday - 0, Monday - 1, ..., Saturday - 6
    const diff = tempDate.getDate() - ((day + 6) % 7); // Adjust to make Monday (1) become 0

    return new Date(tempDate.setDate(diff));
  };

  const renderCalendar = () => {
    const weekStartDate = getWeekStartDate(currentDate);

    const dates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(
        weekStartDate.getFullYear(),
        weekStartDate.getMonth(),
        weekStartDate.getDate() + i
      );
      dates.push(
        <div
          key={i}
          className={`w-1/7 text-center cursor-pointer`}
          onClick={() => handleDateClick(date)}
        >
          <div>
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][date.getDay()]}
          </div>
          <div
            className={`${
              selectedDate &&
              date.toDateString() === selectedDate.toDateString()
                ? "bg-orange2 text-white rounded-xl" // Highlight style for the current date
                : ""
            }`}
          >
            {date.getDate()}
          </div>
        </div>
      );
    }
    return dates;
  };

  const handleDateClick = (date) => {
    setSelectedDate(date); // Set the clicked date
  };

  const goToPreviousWeek = () => {
    const newDate = new Date(currentDate.setDate(currentDate.getDate() - 7));
    setCurrentDate(newDate);
    // Also check if the selected date is within the new week range
    if (
      selectedDate < getWeekStartDate(newDate) ||
      selectedDate > new Date(newDate.setDate(newDate.getDate() + 6))
    ) {
      setSelectedDate(new Date()); // Reset to today if the selected date is not in the new week
    }
  };

  const goToNextWeek = () => {
    const newDate = new Date(currentDate.setDate(currentDate.getDate() + 7));
    setCurrentDate(newDate);
    // Same check as in goToPreviousWeek
    if (
      selectedDate < getWeekStartDate(newDate) ||
      selectedDate > new Date(newDate.setDate(newDate.getDate() + 6))
    ) {
      setSelectedDate(new Date()); // Reset to today if the selected date is not in the new week
    }
  };

  useEffect(() => {
    // Ensure that the selected date is highlighted when the component mounts or currentDate changes
    setSelectedDate(new Date());
  }, [currentDate]);

  return (
    <div className="calendar_Style py-2 px-5 rounded-2xl bg-pureWhite shadow-shadowOne space-y-2">
      <div className="flex justify-between items-center">
        <h2 className="font-semibold">
          {`
            ${currentDate.toLocaleString("default", {
              month: "short",
            })} ${currentDate.getFullYear()}
            `}
        </h2>
        <div className="flex gap-5">
          <button className="text-gray-600 " onClick={goToPreviousWeek}>
            <LeftBtn />
          </button>
          <button className="text-gray-600 " onClick={goToNextWeek}>
            <RightBtn />
          </button>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-1">{renderCalendar()}</div>
      <Events
        cond={true}
        heading={`${
          ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][
            currentDate.getDay()
          ]
        }, ${currentDate.getDate()} ${currentDate.toLocaleString("default", {
          month: "long",
        })} ${currentDate.getFullYear()}`}
        title="Upcoming Events"
        mapNum={5}
      />
    </div>
  );
};

export default Calendar;
